import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import LoginPage from './pages/LoginPage/LoginPage';
import RegisterPage from './pages/RegisterPage/RegisterPage';
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage';
import FramesPage from './pages/FramesPage/FramesPage';
import StatisticsPage from './pages/StatisticsPage/StatisticsPage';
import MainLayout from './components/MainLayout/MainLayout';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import SummaryPage from './pages/SummaryPage/SummaryPage';
import HelpPage from './pages/HelpPage/HelpPage';
import RolesPage from './pages/RolesPage/RolesPage';
import EOEEPage from './pages/EOEEPage/EOEEPage';
import AdminPage from './pages/AdminPage/AdminPage';
import LivePage from './pages/LivePage/LivePage';
import ArchivePage from './pages/ArchivePage/ArchivePage';
import './App.css';
import EquipmentPage from './pages/EquipmentPage/EquipmentPage';
import CameraDetailPage from './pages/CameraDetailPage/CameraDetailPage';
import ViolationsPage from './pages/ViolationsPage/ViolationsPage';
import ViolationEventDetailPage from './pages/ViolationEventDetailPage/ViolationEventDetailPage';
import { useAuth } from './hooks/useAuth';

function LoginRoute() {
  const { authenticated } = useAuth();
  return authenticated ? <Navigate to="/profile" replace /> : <LoginPage />;
}

// Пускает в защищённую часть только авторизованных. Реактивен: при логауте
// или 401 состояние меняется и пользователь сразу уходит на /login.
function RequireAuth({ children }) {
  const { authenticated } = useAuth();
  const location = useLocation();
  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  return isAdmin ? children : <Navigate to="/cameras" replace />;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/" element={<RequireAuth><MainLayout /></RequireAuth>}>
            <Route index element={<Navigate to="/profile" replace />} />
            <Route path="cameras" element={<FramesPage cameraType="PEOPLE" />} />
            <Route path="cameras/:cameraId/live" element={<LivePage />} />
            <Route path="cameras/:cameraId/archive" element={<ArchivePage />} />
            <Route path="cameras/:cameraId/diagnostics" element={<AdminRoute><CameraDetailPage cameraType="PEOPLE" /></AdminRoute>} />
            <Route path="equipment" element={<EquipmentPage cameraType="EQUIPMENT" />} />
            <Route path="equipment/:cameraId/live" element={<LivePage />} />
            <Route path="equipment/:cameraId/archive" element={<ArchivePage />} />
            <Route path="equipment/:cameraId/diagnostics" element={<AdminRoute><CameraDetailPage cameraType="EQUIPMENT" /></AdminRoute>} />
            <Route path="violations" element={<ViolationsPage />} />
            <Route path="violations/:eventId" element={<ViolationEventDetailPage />} />
            <Route path="roles" element={<AdminRoute><RolesPage /></AdminRoute>} />
            <Route path="statistics" element={<StatisticsPage />} />
            <Route path="eoee" element={<EOEEPage />} />
            <Route path="admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
            <Route path="help" element={<HelpPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="summary" element={<SummaryPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/profile" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
